import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  ListGroup,
  ListGroupItem,
  Row } from 'reactstrap';
import {
  Area,
  AreaChart,
  CartesianGrid,
  Cell,
  linearGradient,
  PieChart,
  Pie,
  ResponsiveContainer,
  Tooltip,
  XAxis } from 'recharts';

// Chart Data
const progressData = [{name: 'Progress', value: 75}];
const YTDData = [
  {month: 'OCT', Applications: 75},
  {month: 'NOV', Applications: 81},
  {month: 'DEC', Applications: 84},
  {month: 'JAN', Applications: 92},
  {month: 'FEB', Applications: 98},
  {month: 'MAR', Applications: 106},
  {month: 'APR', Applications: 110},
  {month: 'MAY', Applications: 113},
  {month: 'JUN', Applications: 124},
  {month: 'JUL', Applications: 132},
  {month: 'AUG', Applications: 140},
  {month: 'SEP', Applications: 145},
];

class Dashboard extends Component {
  componentWillUnmount() {
    sessionStorage.setItem('visitedDashboard', true);
  }
  render() {
    const visitedDashboard = sessionStorage.getItem('visitedDashboard');

    return (
      <div className={ `page-dashboard ${ visitedDashboard ? 'noAnimations' : '' }` }>

        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col md={6} className="text-center text-md-left animated fadeInUp">
              <h3>Welcome, Kate!</h3>
              <p className="m-0">You have <strong className="text-primary">13 applications</strong> that need action</p>
            </Col>
            <Col md={6} className="text-right d-none d-md-flex justify-content-end align-items-center animated fadeInUp delay-2s">
              <div>
                <h5 className="mb-0"><span className="text-success">75%</span> to VIP Status</h5>
                <p className="mb-0"><small>113/150 Applications</small></p>
              </div>
              <div className="progress-bar-small ml-3">
                <PieChart width={80} height={80} onMouseEnter={this.onPieEnter}>
                  <Pie
                    data={progressData}
                    cx={35}
                    cy={35}
                    innerRadius={35}
                    outerRadius={40}
                    startAngle={-90}
                    endAngle={-360}
                    fill="#04BC6C"
                    paddingAngle={2}
                    animationBegin={2000}
                    dataKey="value"
                  >
                  	{
                    	progressData.map((entry, index) => <Cell />)
                    }
                  </Pie>
                </PieChart>
                <div className="center-content"><img src="/icons/vip.svg" alt="VIP" /></div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={6} lg={4}>

              <div className="animated fadeInUp delay-200ms">
                <Card id="StartCTACard" inverse color="primary" tag="a" href="#">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <div className="icon-bubble large mr-3 ml-xl-2">
                        <img src="icons/lusa-logo.svg" alt="LendingUSA" className="m-1" />
                      </div>
                      <h3 className="text-white mb-0">Start here to submit a new application</h3>
                    </div>
                  </CardBody>
                  <Button color="primary" tag="div">Start New Appplication</Button>
                </Card>
              </div>

              <Card id="CheckAppStatus" className="animated fadeInUp delay-300ms">
                <CardHeader>Check App Status</CardHeader>
                <CardBody>
                  <Form>
                    <FormGroup className="mb-0 input-inline input-btn-inline">
                      <Input type="text" name="applicant" id="applicantSearch" placeholder="Applicant Name" />
                      <Button color="primary" className="btn-icon" tag="a"><img src="icons/arrow-right.svg" alt="Submit" /></Button>
                    </FormGroup>
                  </Form>
                </CardBody>
              </Card>

              <Card className="animated fadeInUp delay-600ms">
                <CardHeader>Merchant Tools</CardHeader>
                <ListGroup>
                  <ListGroupItem tag="a" href="/text-to-apply" className="d-flex">
                    <div className="icon-bubble mr-2"><img src="icons/text-to-apply.svg" alt="Text to Apply" /></div>
                    <div>
                      <h5 className="mb-0">Text to Apply &nbsp;<Badge color="warning">NEW</Badge></h5>
                      <small>Text application link to your customer</small>
                    </div>
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/applications" className="d-flex">
                    <div className="icon-bubble mr-2"><img src="icons/review.svg" alt="Review" /></div>
                    <div>
                      <h5 className="mb-0">Review Applications</h5>
                      <small>View current and past applications</small>
                    </div>
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/brochures" className="d-flex">
                    <div className="icon-bubble mr-2"><img src="icons/brochures.svg" alt="Request Brochures" /></div>
                    <div>
                      <h5 className="mb-0">Request Brochures</h5>
                      <small>Order more physical brochures</small>
                    </div>
                  </ListGroupItem>
                </ListGroup>
              </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card  className="animated fadeInUp delay-400ms">
                <CardHeader>Action Center</CardHeader>
                <CardBody>
                  <Container fluid className="mt-1">

                    <Row className="text-center mb-1">
                      <Col xs={6} className="mb-3">
                        <Link to="/applications" className="d-flex flex-column">
                          <div className="icon-bubble large ml-auto mr-auto mb-2">
                            <img src="icons/signature.svg" alt="Need Signature" />
                            <Badge pill color="danger" className="top-right">13</Badge>
                          </div>
                          <h5 className="m-0">Need Signature</h5>
                        </Link>
                      </Col>
                      <Col xs={6} className="mb-3">
                        <Link to="/applications" className="d-flex flex-column">
                          <div className="icon-bubble large ml-auto mr-auto mb-2">
                            <img src="icons/expire.svg" alt="Due to Expire" />
                            <Badge pill color="danger" className="top-right">9</Badge>
                          </div>
                          <h5 className="m-0">Due to Expire</h5>
                        </Link>
                      </Col>
                      <Col xs={6} className="d-flex flex-column">
                        <Link to="/applications" className="d-flex flex-column">
                          <div className="icon-bubble large  ml-auto mr-auto mb-2">
                            <h3 className="mb-0">32</h3>
                            <small>Total</small>
                          </div>
                          <h5 className="m-0">Need Info</h5>
                        </Link>
                      </Col>
                      <Col xs={6} className="d-flex flex-column">
                        <Link to="/applications" className="d-flex flex-column">
                          <div className="icon-bubble large  ml-auto mr-auto mb-2">
                            <h3 className="mb-0">265</h3>
                            <small>Total</small>
                          </div>
                          <h5 className="m-0">Incomplete</h5>
                        </Link>
                      </Col>
                    </Row>

                  </Container>
                </CardBody>
              </Card>

              <Card className="animated fadeInUp delay-700ms">
                <CardHeader>Knowledge Base</CardHeader>
                <ListGroup className="pt-0">
                  <ListGroupItem className="training-videos">
                    <Row>
                      <h6 className="w-100 text-center">Training Videos</h6>
                    </Row>
                    <Row>
                      <Col xs="4">
                        <Link to="/" className="video-link">
                          <div className="video-preview video1" style={{ backgroundImage: "url(images/video1.jpg)" }}>
                            <img src="icons/play.svg" height="12" alt="Play Video" />
                          </div>
                          <span>Welcome</span>
                        </Link>
                      </Col>
                      <Col xs="4">
                        <Link to="/" className="video-link">
                          <div className="video-preview video2" style={{ backgroundImage: "url(images/video2.jpg)" }}>
                            <img src="icons/play.svg" height="12" alt="Play Video" />
                          </div>
                          <span>Your Portal</span>
                        </Link>
                      </Col>
                      <Col xs="4">
                        <Link to="/" className="video-link">
                          <div className="video-preview video3" style={{ backgroundImage: "url(images/video3.jpg)" }}>
                            <img src="icons/play.svg" height="12" alt="Play Video" />
                          </div>
                          <span>Action Center</span>
                        </Link>
                      </Col>
                    </Row>
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/resource-center" className="d-flex">
                    <div className="icon-bubble mr-2"><img src="icons/merchant-resources.svg" alt="Merchant Resources" /></div>
                    <div>
                      <h5 className="mb-0">Merchant Resources</h5>
                      <small>Best practices, website banners & more</small>
                    </div>
                  </ListGroupItem>
                </ListGroup>
              </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card className="animated fadeInUp delay-500ms">
                <CardHeader>Loan Stats</CardHeader>
                <ButtonGroup size="sm" className="d-flex">
                  <Button color="primary">Week</Button>
                  <Button color="primary">MTD</Button>
                  <Button color="primary" active>YTD</Button>
                </ButtonGroup>
                <CardBody className="no-border">
                  <ResponsiveContainer className="card-chart">
                    <AreaChart data={YTDData}>
                      <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="5%" stopColor="#3989E3" stopOpacity={0.15}/>
                          <stop offset="95%" stopColor="#3989E3" stopOpacity={0.05}/>
                        </linearGradient>
                      </defs>
                      <XAxis dataKey="month" tickLine={false} interval={0} fontSize="10" tickSize={10} dx={13} />
                      <CartesianGrid stroke="#E7E7E7" vertical={false} />
                      <Tooltip />
                      <Area type="monotone" dataKey="Applications" strokeWidth="3" stroke="#AACEF6" fillOpacity={1} fill="url(#colorUv)" animationBegin={900} />
                    </AreaChart>
                  </ResponsiveContainer>
                </CardBody>
                <ListGroup className="pt-0">
                  <ListGroupItem className="text-center">
                    <Row>
                      <Col className="d-flex align-items-center">
                        <h6 className="mb-0 text-left">Total Loans Approved<br />
                        <span>Year to Date</span></h6>
                      </Col>
                      <Col className="text-right">
                        <h2 className="text-primary mb-1">$384,387</h2>
                      </Col>
                    </Row>
                  </ListGroupItem>
                </ListGroup>
              </Card>

              <Card className="animated fadeInUp delay-800ms">
                <CardHeader>Transaction Tools</CardHeader>
                <ListGroup>
                  <ListGroupItem tag="a" href="#" className="d-flex">
                    <div className="icon-bubble mr-2">
                      <img src="icons/completion-date.svg" alt="Confirm Completion Date" />
                      <Badge pill color="danger" className="top-right">3</Badge>
                    </div>
                    <div>
                      <h5 className="mb-0">Confirm Completion Date &nbsp;<Badge color="warning">NEW</Badge></h5>
                      <small>Confirm the completion date of <br className="d-lg-none d-xl-block" /> service and products provided</small>
                    </div>
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="#" className="d-flex">
                    <div className="icon-bubble mr-2">
                      <img src="icons/refund.svg" alt="Request Refund" />
                      <Badge pill color="danger" className="top-right">1</Badge>
                    </div>
                    <div>
                      <h5 className="mb-0">Request Refund &nbsp;<Badge color="warning">NEW</Badge></h5>
                      <small>Start the process for a refund</small>
                    </div>
                  </ListGroupItem>
                </ListGroup>
              </Card>

            </Col>
          </Row>

        </Container>

      </div>
    );
  }
}

export default Dashboard;
